module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-16.edc19a12.jpg";